<template src="./index.html"></template>
<script>
	import data from './data.js';
export default {
	props: {
		importtk: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			//表格筛选
			shaidiag: false,
			headData:  data.headData,
			//表格
			tableHeight: null,
			tableData: [],
			pagination: data.pagination,
			tablekey: 0,
			value1:""
		};
	},
	created() {},
	mounted() {},
	methods: {
		closediag() {
		  this.$emit("closediag", false);
		},
		DocumentType() {
			this.$upload({
				uploadurl: "",
				uploadtitle: "选择文件",
				params: {}
			})
		},
		//表格分页
		sizechange(e) {
			this.pagination.pageSize = e;
		},
		currentChange(e) {
			this.pagination.pageNum = e;
		},
		
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
